module.exports = __webpack_public_path__ + "media/images/riders/HALEY_SMITH-eea73ed47c541bb5cf92a0091d4d3a56.png";